/**
 * @fileoverview POST handler for the "/decisioning_studio_agents/:app_group_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { decisioningStudioAgentsAppGroupIdCacheKeys } from "./constants";
import type {
  PostDecisioningStudioAgentsAppGroupIdProps,
  PostDecisioningStudioAgentsAppGroupIdResult,
} from "./types";

export const postDecisioningStudioAgentsAppGroupId = reactQueryMutationAdapter(
  decisioningStudioAgentsAppGroupIdCacheKeys,
  ({
    appGroupId,
    displayName,
  }: PostDecisioningStudioAgentsAppGroupIdProps): Promise<PostDecisioningStudioAgentsAppGroupIdResult> => {
    return fetch(
      `/decisioning_studio_agents/${appGroupId}`,
      "POST",
      {
        dsa: { display_name: displayName },
      },
      undefined,
      {
        // The create modal renders errors inline — no global error modal.
        propagateFetchRequestError: false,
      }
    );
  }
);
